import { AfterViewInit, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserHelper } from '@helpers/user.helper';
import { ApiService } from '@services/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'idle-dialog',
  templateUrl: '../sharedTemplates/idle.dialog.html',
})
export class IdleDialog implements AfterViewInit {
  count = 30; //seconds

  interval;

  constructor(private _ApiService: ApiService, private _UserHelper: UserHelper, public dialogRef: MatDialogRef<IdleDialog>, private _router: Router) {}

  closeD() {
    clearInterval(this.interval);
    this.dialogRef.close();
  }

  closeDialog() {
    this.realityCheckPlayer(false);
    this._UserHelper.signInListener.emit(true);
    this.closeD();
  }

  ngAfterViewInit(): void {
    this.interval = setInterval(() => {
      this.count--;
      if (this.count < 1) {
        //this.count = 60;
        this.closeD();

        if (this._UserHelper.isSignedIn) {
          this.realityCheckPlayer(true);
          setTimeout(() => {
            this.timeOut();

            this._ApiService
              .signOut()
              .then(result => {
                this._UserHelper.userLogOut();

                this.refreshAPP();
              })
              .catch(err => console.log('idle.dialog', err));
          }, 1000);
        } else {
          this._router.navigate(['/home']);
        }

        clearInterval(this.interval);
        this.interval = null;
      }
    }, 1000);
    this.dialogRef.afterClosed().subscribe(() => {
      clearInterval(this.interval);
    });
  }

  ngOnInit(): void {
    this.realityCheckProvider();
  }
  realityCheckProvider() {
    this._ApiService
      .realityCheckProvider()
      .then(x => {
        console.warn(x);
      })
      .catch(e => {
        console.error(e);
      });
  }
  timeOut() {
    this._ApiService
      .timeOut()
      .then(x => {
        console.warn(x);
      })
      .catch(e => {
        console.error(e);
      });
  }
  realityCheckPlayer(activityExpired: boolean) {
    this._ApiService
      .realityCheckPlayer(activityExpired)
      .then(x => {
        console.warn(x);
      })
      .catch(e => {
        console.error(e);
      });
  }
  refreshAPP() {
    window.location.href = '/home';
  }
}
